import { DataTable } from "../../../../../../../shared/components/data-table/DataTable";

const UserPermissionsTable = ({ data }) => {
  const columns = [
    {
      accessorKey: "application",
      header: "Aplicación",
      cell: ({ row }) => <div>{row.original.application.name}</div>,
    },
    {
      accessorKey: "role",
      header: "Rol",
      cell: ({ row }) => <div>{row.original.role.name}</div>,
    },
    {
      accessorKey: "key",
      header: "Clave",
    },
    {
      accessorKey: "value",
      header: "Valor",
    },
  ];

  return <DataTable data={data} columns={columns} />;
};

export default UserPermissionsTable;
